export enum DeviceTypeEnum {
  WEB = 3,
}
